import React from 'react'

interface CalendarIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string | number
  height?: string | number
  fill?: string
}

export const CalendarIcon: React.FC<CalendarIconProps> = ({
  width = 20,
  height = 20,
  fill = '#A1A1A1',
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 32 33"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        d="M23 7.5H22V5.5H20V7.5H12V5.5H10V7.5H9C7.89 7.5 7.01 8.4 7.01 9.5L7 23.5C7 24.6 7.89 25.5 9 25.5H23C24.1 25.5 25 24.6 25 23.5V9.5C25 8.4 24.1 7.5 23 7.5ZM23 23.5H9V12.5H23V23.5Z"
        fill={fill}
      />
    </svg>
  )
}
